import type { CityConfig } from "@/pages/city-template/types";

export const tarrytownConfig: CityConfig = {
  city: "Tarrytown",
  state: "New York",
  stateAbbr: "NY",
  slug: "tarrytown",
  route: "/cities/tarrytown",
  title: "Emergency & Expedited Passport Tarrytown NY | Same Day Passport",
  metaDescription:
    "Emergency passport Tarrytown NY — same day, 24-hour, and 3-5 day expedited passport processing for Westchester County. Fast Passport Center serves Tarrytown, Sleepy Hollow, White Plains, and all Hudson River Valley communities.",
  h1: "Emergency & Expedited Passport Services in Tarrytown, NY",
  heroSubtitle:
    "Tarrytown's fast passport solution — from the Hudson River Valley to the Mario Cuomo Bridge. Whether you're flying out of Westchester County Airport or JFK, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Historic%20Tarrytown%20New%20York%20downtown%20along%20the%20Hudson%20River%20with%20charming%20colonial%20architecture%2C%20Sleepy%20Hollow%20lighthouse%20in%20the%20distance%2C%20Tappan%20Zee%20Bridge%20visible%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20Westchester%20County%20Hudson%20River%20Valley%20scene%20with%20beautiful%20waterfront%20and%20historic%20buildings&width=1600&height=700&seq=ny-tarrytown-hero-001&orientation=landscape",
  heroImageAlt: "Historic Tarrytown New York along the Hudson River with colonial architecture and Tappan Zee Bridge",
  geoPosition: "41.0762; -73.8587",
  geoPlacename: "Tarrytown, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~25 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Tarrytown", zips: "10591" },
    { name: "Sleepy Hollow", zips: "10591" },
    { name: "White Plains", zips: "10601, 10602, 10603, 10604, 10605, 10606, 10607, 10610" },
    { name: "Yonkers", zips: "10701, 10702, 10703, 10704, 10705, 10706, 10707, 10708, 10709, 10710" },
    { name: "New Rochelle", zips: "10801, 10802, 10803, 10804, 10805" },
    { name: "Mount Vernon", zips: "10550, 10551, 10552, 10553" },
    { name: "Scarsdale", zips: "10583" },
    { name: "Eastchester", zips: "10709" },
    { name: "Bronxville", zips: "10708" },
    { name: "Harrison", zips: "10528" },
    { name: "Rye", zips: "10580" },
    { name: "Mamaroneck", zips: "10538, 10543" },
    { name: "Larchmont", zips: "10538" },
    { name: "Ossining", zips: "10562" },
    { name: "Nyack", zips: "10960" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Tarrytown travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Tarrytown residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Hudson River Valley",
      desc: "Tarrytown, Sleepy Hollow, White Plains, and all Westchester County communities along the Hudson River — we serve the entire region.",
    },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Tarrytown, NY",
      rating: 5,
      text: "Had a business trip to London in 5 days. Fast Passport Center got my expedited passport processed in 3 days. They were incredibly thorough and professional.",
      service: "Expedited Passport",
    },
    {
      name: "Robert K.",
      location: "Sleepy Hollow, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. The agent caught an issue with my photo that would have delayed me.",
      service: "Passport Renewal",
    },
    {
      name: "Maria S.",
      location: "Ossining, NY",
      rating: 5,
      text: "First-time passport for my daughter's study abroad program. The agent helped us with the acceptance clerk appointment at the Tarrytown post office. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "tarrytown-1",
      name: "Tarrytown Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1 Depot Plaza",
      city: "Tarrytown",
      state: "NY",
      zip: "10591",
      phone: "914-631-2670",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Tarrytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Tarrytown passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "tarrytown-2",
      name: "Sleepy Hollow Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "28 Beekman Avenue",
      city: "Sleepy Hollow",
      state: "NY",
      zip: "10591",
      phone: "914-631-5541",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Sleepy Hollow (adjacent to Tarrytown)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Sleepy Hollow and Tarrytown residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "tarrytown-3",
      name: "White Plains Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "100 Fisher Avenue",
      city: "White Plains",
      state: "NY",
      zip: "10606",
      phone: "914-948-3424",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "White Plains (~8 miles)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving White Plains, Tarrytown, and all Westchester County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Tarrytown?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Tarrytown residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Tarrytown?",
      a: "The Tarrytown Post Office at 1 Depot Plaza is the major Tarrytown passport acceptance facility. The Sleepy Hollow Post Office at 28 Beekman Avenue and White Plains Post Office at 100 Fisher Avenue are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Tarrytown?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Tarrytown, Sleepy Hollow, and White Plains. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Tarrytown?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Tarrytown passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Tarrytown?",
      a: "The fastest way to renew a passport in Tarrytown is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Tarrytown?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Tarrytown and all Westchester County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Tarrytown?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Tarrytown. We serve the Hudson River Valley and all of Westchester County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Tarrytown", address: "various CVS locations across Tarrytown, Sleepy Hollow, and White Plains", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — White Plains", address: "various Walgreens locations throughout White Plains and Westchester County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Tarrytown", address: "various UPS Store locations in Tarrytown and White Plains", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — White Plains", address: "various FedEx Office locations across White Plains", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — White Plains", address: "various Walmart locations in White Plains area", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — White Plains",
      address: "200 Hamilton Avenue, White Plains, NY 10601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "White Plains DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Yonkers",
      address: "1 Larkin Center, Yonkers, NY 10710",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Yonkers DMV office serving south Westchester, Yonkers, and Tarrytown residents.",
      featured: false,
    },
    {
      name: "NYS DMV — New Rochelle",
      address: "100 Bauer Avenue, New Rochelle, NY 10801",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "New Rochelle DMV office serving southeast Westchester County communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~15 miles from Tarrytown",
      address: "240 Airport Road, White Plains, NY 10604",
      note: "Regional airport with flights to major U.S. hubs. Primary airport for Tarrytown and Westchester County travelers.",
      flightUrl: "https://www.westchestergov.com/airport",
      flightLabel: "HPN Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~30 miles from Tarrytown",
      address: "Queens, NY 11430",
      note: "Major international airport with flights worldwide. Alternative for Tarrytown travelers.",
      flightUrl: "https://www.jfk.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~25 miles from Tarrytown",
      address: "Queens, NY 11371",
      note: "Domestic and international flights. Popular alternative for Tarrytown residents flying to domestic destinations.",
      flightUrl: "https://www.laguardia.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Tarrytown travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Tarrytown residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Tarrytown residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Tarrytown residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Tarrytown, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Tarrytown residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Tarrytown travelers with immediate departure needs from Westchester County Airport, JFK, or LaGuardia." },
    { name: "Passport Renewal", description: "Fast passport renewal for Tarrytown residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Tarrytown residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Tarrytown residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Tarrytown and Westchester County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Tarrytown." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Tarrytown travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Tarrytown travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Tarrytown team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Tarrytown address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Fishkill", route: "/cities/fishkill" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Tarrytown and all of Westchester County as a remote courier service. We do not have a physical office in Tarrytown, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Tarrytown area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Tarrytown and all of Westchester County. From the Hudson River Valley to Sleepy Hollow, White Plains to Ossining — we serve the entire Westchester region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Tarrytown and all surrounding communities along the Hudson River and throughout Westchester County. Whether you're in Sleepy Hollow, Ossining, or Nyack, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Tarrytown customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Tarrytown travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Tarrytown travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Tarrytown. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default tarrytownConfig;